import styled from "styled-components";
import Modal, { ModalProps } from "../../common/components/Modal";
import BasicButton from "../../common/components/BasicButton";

function DeletePostModal({ open, onClose }: ModalProps) {
  return (
    <Modal
      title="게시물 삭제"
      open={open}
      onClose={onClose}
      width="400px"
      height="400px"
    >
      <Warning>
        <p>한번 삭제된 게시물 정보는 복구할 수 없습니다.</p>
        <p>정말 삭제하시겠습니까?</p>
      </Warning>
      <BasicButton text="취소" variant="outlined" />
      <BasicButton text="삭제" variant="error" />
    </Modal>
  );
}

const Warning = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: 250,
  gap: 10,

  "&>p": {
    fontWeight: "bold",
    fontSize: 18,
    margin: 0,
    color: theme.color.darkGray,
  },
}));

export default DeletePostModal;
